import type { SupportTicketListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import DotsVerticalIcon from "@redotech/redo-icons/dots-vertical.svg";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@redotech/redo-web/components/ui/dropdown-menu";
import { memo, useCallback } from "react";
import { SupportTicketActionsDropdown } from "../../../actions/support-ticket-actions-dropdown";
import { useSupportTicketsTableContext } from "../../support-tickets-table-context";

interface SupportTicketActionsMenuProps {
  conversation: SupportTicketListItemResponse;
}

export const SupportTicketActionsMenu = memo(function SupportTicketActionsMenu({
  conversation,
}: SupportTicketActionsMenuProps) {
  const { actionMenuOpenForId, setActionMenuOpenForId } =
    useSupportTicketsTableContext();

  const isOpen = actionMenuOpenForId === conversation.id;
  const setIsOpen = useCallback(
    (open: boolean) => setActionMenuOpenForId(open ? conversation.id : null),
    [setActionMenuOpenForId, conversation.id],
  );

  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <DropdownMenu onOpenChange={setIsOpen} open={isOpen}>
      <DropdownMenuTrigger
        className="flex h-8 w-8 items-center justify-center rounded hover:bg-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <DotsVerticalIcon className="h-4 w-4" />
      </DropdownMenuTrigger>
      <SupportTicketActionsDropdown
        conversation={conversation}
        isOpen={isOpen}
        onClose={handleClose}
        supportTicketId={conversation.id}
      />
    </DropdownMenu>
  );
});
